import { Meta } from "./meta";

export class Evento {
    ambitos: any[];
    id: number;
    nombre: string;
    resumen: string;
    resumenTXT: string;
    categoria: any;
    categoriaID: number;
    cursos: any[];
    editores: any[];
    isActive: boolean;
    isDeleted: boolean;
    isEditable: boolean;
    public isSelected: boolean = false;
    materias: any[];
    tags: any[];
    metas?: Meta[];
    tarea?: any;

    constructor(evento: {
        id: number,
        nombre?: string,
        resumen?: string,
        resumenTXT?: string,
        categoria?: any,
        categoriaID?: number,
        cursos?: any[],
        editores?: any[],
        materias?: any[],
        isActive?: boolean,
        isDeleted?: boolean,
        isEditable?: boolean,
        isSelected?: boolean,
        metas?: Meta[],
        tarea?: any
    }) {
        this.id = evento.id;
        this.nombre = evento.nombre || '';
        this.resumen = evento.resumen || '';
        this.resumenTXT = evento.resumenTXT || '';
        this.categoria = evento.categoria || {};
        this.categoriaID = evento.categoriaID || 0;
        this.isActive = evento.isActive || true;
        this.isDeleted = evento.isDeleted || false;
        this.isEditable = evento.isEditable || true;
        this.cursos = evento.cursos || [];
        this.editores = evento.editores || [];
        this.materias = evento.materias || [];
        this.isSelected = evento.isSelected || false;
        this.metas = evento.metas || [];
        this.tarea = evento.tarea || null;
    }
}